<template>
  <section>
    <v-card flat>
      <v-container class="pa-0" style="padding-bottom: 100px">
        <v-row>
          <v-col cols="12" sm="4" offset-sm="4">
            <div
              style="
                border: 1px solid lightgrey;
                border-radius: 3px;
                padding: 8px;
                display: flex;
                justify-content: space-between;
              "
            >
              <div style="display: flex; flex-direction: column">
                <span style="font-size: 12px">Total presupuesto</span>
                <span
                  ><b>${{ currentTechReq.budget_amount }}</b></span
                >
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-end;
                "
              >
                <span style="font-size: 12px">Total cobros</span>
                <span
                  ><b>${{ currentTechReq.charged_amount }}</b></span
                >
              </div>
            </div>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headersCharges"
          :items="chargeList"
          class="hidden-sm-and-down mt-6 mb-12"
          hide-default-footer
        >
          <template v-slot:item="{ item }">
            <tr @click="showChargeDetail(item)" style="cursor: pointer">
              <td>{{ formatDate(item.create_at) }}</td>
              <td>{{ item.category_charge_description }}</td>
              <td>{{ item.description }}</td>
              <td>${{ item.amount }}</td>
            </tr>
          </template>
          <!-- <template v-slot:item.liquidated="{ item }">
            <td
              style="display: flex; justify-content:center; align-items: center;"
            >
              <v-icon v-if="item.liquidated" color="secondary">
                check
              </v-icon>
              <span v-else>---</span>
            </td>
          </template> -->
          <!-- <template v-slot:item.actions="{ item }">
            <td
              style="display: flex; justify-content:center; align-items: center;"
            >
              <span>
                <Loader small v-if="deletingCharge === item.id" />
              </span>
              <v-icon
                v-if="!item.liquidated && !(deletingCharge === item.id)"
                @click="deleteCharge(item)"
              >
                delete_outline
              </v-icon>
              <span v-if="item.liquidated">---</span>
            </td>
          </template> -->
        </v-data-table>
        <v-data-table
          :headers="headersCharges"
          :items="chargeList"
          class="hidden-md-and-up"
          style="padding: 0 10px"
          no-data-text="No se registran cobros"
          hide-default-header
          hide-default-footer
        >
          <template v-slot:item="{ item }">
            <v-container class="charge-item" @click="showChargeDetail(item)">
              <v-row>
                <span style="font-size: 12px">{{
                  item.category_charge_description
                }}</span>
                <v-spacer />
                <span style="font-size: 12px">{{
                  formatDate(item.create_at)
                }}</span>
              </v-row>
              <v-row>
                <span>{{ item.description }}</span>
                <v-spacer />
                <span
                  ><b>${{ item.amount }}</b></span
                >
              </v-row>
            </v-container>
            <v-row>
              <v-divider></v-divider>
            </v-row>
          </template>
        </v-data-table>
        <v-col cols="12" sm="4" offset-sm="4">
          <v-btn
            outlined
            block
            large
            color="primary"
            @click="showChargeDetail(null)"
          >
            <v-icon color="primary" class="mr-2">add</v-icon>
            REGISTRAR COBRO
          </v-btn>
        </v-col>
        <v-col cols="12" sm="4" offset-sm="4">
          <v-btn @click="rejectCharge" outlined block color="rapired" dark large
            >negacion al pago</v-btn
          >
        </v-col>
        <v-col cols="12" sm="4" offset-sm="4">
          <v-btn outlined block @click="finalizeService" color="secondary" large
            >finalizar pedido</v-btn
          >
        </v-col>
      </v-container>
    </v-card>
    <ChargeItemDialog
      v-if="chargeItemDialog"
      :show="chargeItemDialog"
      :charge="{ ...currentCharge, request_technician: currentTechReq.id }"
      @close-dialog="chargeItemDialog = false"
      @save-charge="saveCharge($event)"
    />
    <ChargeRejectDialog
      v-if="chargeRejectDialog"
      :visitId="currentVisit.id"
      :show="chargeRejectDialog"
      @reject-charge="goToRequest"
      @close-dialog="chargeRejectDialog = false"
    />
    <FinalizeServiceDialog
      v-if="finalizeServiceDialog"
      :show="finalizeServiceDialog"
      :requestId="currentTechReq.request.id"
      :visitId="currentVisit.id"
      @reload-request="loadRequestFromAPI"
      @close-dialog="finalizeServiceDialog = false"
    />
  </section>
</template>
<script>
import moment from "moment";
import Loader from "./Loader";
import ChargeItemDialog from "./ChargeItemDialog";
import ChargeRejectDialog from "./ChargeRejectDialog";
import FinalizeServiceDialog from "./FinalizeServiceDialog";

export default {
  name: "charge-list",
  components: {
    Loader,
    ChargeItemDialog,
    ChargeRejectDialog,
    FinalizeServiceDialog,
  },
  data() {
    return {
      finalizeServiceDialog: false,
      chargeItemDialog: false,
      chargeRejectDialog: false,
      requestId: null,
      currentVisit: {},
      currentTechReq: {},
      chargeList: [],
      deletingCharge: null,
      headersCharges: [
        // { text: "ID", value: "id", show: true, sortable: false },
        { text: "Fecha", value: "create_at", show: true, sortable: false },
        {
          text: "Tipo",
          value: "category_charge_description",
          sortable: false,
          show: true,
        },
        {
          text: "Descripción",
          value: "description",
          sortable: false,
          show: true,
        },
        {
          text: "Monto",
          value: "amount",
          show: true,
          sortable: false,
        },
        // {
        //   text: "Liquidado",
        //   value: "liquidated",
        //   align: "center",
        //   show: true,
        //   sortable: false
        // },
        // {
        //   text: "Acciones",
        //   value: "actions",
        //   align: "center",
        //   sortable: false,
        //   show: true
        // }
      ],
    };
  },
  mounted() {
    if (this.requestsAreLoaded && this.$route.query.requestId) {
      this.loadRequestFromStore();
    }
  },
  watch: {
    "$store.state.user_techReqs": function () {
      this.loadRequestFromStore();
    },
  },
  computed: {
    requestsAreLoaded: function () {
      if (this.$store.state.user_techReqs.length) return true;
      return false;
    },
    requestIsActive: function () {
      if (
        this.currentTechReq &&
        this.currentTechReq.request &&
        this.currentTechReq.request.status_request &&
        (this.currentTechReq.request.status_request.id === 10 ||
          this.currentTechReq.request.status_request.id === 11 ||
          this.currentTechReq.request.status_request.id === 12)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    goToRequest() {
      this.$router.push({
        name: "request-detail",
        params: { id: this.currentTechReq.request.id },
      });
    },
    rejectCharge() {
      this.chargeRejectDialog = true;
    },
    finalizeService() {
      this.finalizeServiceDialog = true;
    },
    saveCharge(charge) {
      if (!charge.id) {
        this.axios.post(`charge/`, charge).then(() => {
          this.loadRequestFromAPI();
        });
      } else {
        this.axios.patch(`charge/${charge.id}`, charge).then(() => {
          this.loadRequestFromAPI();
        });
      }
    },
    loadRequestFromStore() {
      this.currentTechReq = this.$store.state.user_techReqs.find(
        (item) => item.request.id === Number(this.$route.query.requestId)
      );
      if (
        this.currentTechReq &&
        this.currentTechReq.request &&
        this.currentTechReq.request.id
      ) {
        this.requestId = this.currentTechReq.request.id;
      } else {
        this.$router.replace("visit-list");
      }
      let requestVisits = this.currentTechReq.visit;

      this.currentVisit = requestVisits.find(
        (visit) => visit.visit_status === 1
      );

      !this.currentVisit &&
        (this.currentVisit = requestVisits.find(
          (visit) => visit.visit_status === 8
        ));

      !this.currentVisit &&
        requestVisits.length &&
        (this.currentVisit = requestVisits[0]);
      this.$store.commit("set_app_title", `Cobros pedido #${this.requestId}`);
      window.scrollTo(0, 0);
      this.getChargeList();
    },
    getChargeList() {
      this.chargeList = this.currentTechReq.charge.map((item) => {
        let _item = {
          ...item,
          id: item.id ? item.id : item.uuid,
          style: { backgroundColor: "transparent" },
        };

        if (!item.liquidated && item.id) {
          _item.canDelete = true;
        }

        return _item;
      });
    },
    showChargeDetail(item) {
      if (item) {
        this.currentCharge = item;
      } else {
        this.currentCharge = {};
      }
      this.chargeItemDialog = true;
    },
    deleteCharge(item) {
      this.deletingCharge = item.id;
      this.axios.delete(`charge/${item.id}`).then(() => {
        this.deletingCharge = null;
        this.loadRequestFromAPI();
      });
    },
    loadRequestFromAPI() {
      this.$store.commit("set_loading_request_detail", true);
      this.axios
        .get(`/request_technician/${this.currentTechReq.id}/`)
        .then((response) => {
          this.currentTechReq = response.data;
          this.getChargeList();

          let requestVisits = this.currentTechReq.visit;

          this.currentVisit = requestVisits.find(
            (visit) => visit.visit_status === 1
          );

          !this.currentVisit &&
            (this.currentVisit = requestVisits.find(
              (visit) => visit.visit_status === 8
            ));

          !this.currentVisit &&
            requestVisits.length &&
            (this.currentVisit = requestVisits[0]);

          this.currentTechReq &&
            this.$store.commit("set_current_techReq", this.currentTechReq);
          this.currentTechReq &&
            this.$store.commit("updateCachedTechReq", this.currentTechReq);
          this.$store.commit("set_loading_request_detail", false);
        })
        .catch(() => {
          this.$store.commit("set_loading_request_detail", false);
        });
    },
    formatDate(date) {
      const _date = new Date();
      const today = moment(_date).format("YYYY-MM-DD");
      if (date === today) {
        return "Hoy";
      } else {
        return moment(date, "YYYY-MM-DD").format("dddd DD MMMM, YYYY");
      }
    },
  },
};
</script>
<style scoped>
@media (min-width: 960px) {
  .pull-right-on-desktop {
    display: flex;
    justify-content: flex-end;
  }
  .fix-desk {
    transform: translateX(260px);
  }
}
.menu-container {
  display: flex;
  justify-content: flex-end;
}
.bottom-bar {
  position: fixed;
  padding: 0 24px;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100px;
}
.pb24 {
  padding-bottom: 84px;
}
.pb0 {
  padding-bottom: 0;
}
.pt0 {
  padding-top: 0;
}
.p0 {
  padding: 0;
}
.m0 {
  margin: 0;
}
.date {
  text-transform: capitalize;
  text-align: left;
}
.status-name-cont {
  height: 30px;
  background: #c8272a;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 12px;
  text-transform: capitalize;
}
</style>
